import React, { useContext } from "react";

import { LutronDesignerMessageType } from "../../models";

export interface ToolContextState {
  token: string;
  tool: string;
  version: string;
  isOffline: boolean;
  capabilities?: LutronDesignerMessageType[];
}

export enum Tool {
  LutronDesigner = "Lutron Designer",
}

export const ToolContext = React.createContext<ToolContextState>(
  undefined as unknown as ToolContextState,
);

export function useToolContext() {
  return useContext(ToolContext);
}

function isCapabilitiesValidStringArray(
  capabilities?: LutronDesignerMessageType[],
) {
  if (Array.isArray(capabilities))
    return capabilities.every((capability) => typeof capability === "string");
  return false;
}

export function isToolContextState(value: unknown): value is ToolContextState {
  // verify if value is an object
  if (typeof value !== "object") return false;
  // verify if value is not null
  if (value === null) return false;

  const { token, tool, version, isOffline, capabilities } =
    value as ToolContextState;

  // verify if token, tool, version are string
  if (typeof token !== "string") return false;
  if (typeof tool !== "string") return false;
  if (typeof version !== "string") return false;
  // verify if isOffline is a boolean
  if (typeof isOffline !== "boolean") return false;
  // verify if capabilities is a string array or undefined
  if (
    !isCapabilitiesValidStringArray(capabilities) &&
    typeof capabilities !== "undefined"
  )
    return false;

  return true;
}
